import React from 'react';
import styled from 'styled-components';
import { Divider } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { spaces } from '@99designs/emu/settings';

const SidebarHeaderSectionWrapper = styled.div`
    /* TODO, move this out of SidebarHeader and into Fullscreen */
    overflow-x: hidden; /* Fix to disable horizontal scroll issue on Safari iOS */
    overflow-y: hidden; /* Fix a bug caused by the above fix 👆 */
    padding: ${spaces['1bu']};

    ${mediaQuery.between('normal', 'large')} {
        padding: ${spaces['1.5bu']} ${spaces['2bu']};
    }
    ${mediaQuery.only('large')} {
        padding: ${spaces['1.5bu']} ${spaces['2bu']};
    }
`;

interface SidebarHeaderSectionProps {
    children?: React.ReactNode;
    showDivider?: boolean;
}

function SidebarHeaderSection({ children, showDivider }: SidebarHeaderSectionProps) {
    return (
        <>
            <SidebarHeaderSectionWrapper>{children}</SidebarHeaderSectionWrapper>
            {showDivider && <Divider />}
        </>
    );
}

export default SidebarHeaderSection;
